import React from 'react';
import styles from './styles.module.css'
export default function EmptyData() {
  return <div className={styles.data}>Notification Settings not found</div>;
}
